import Fun from "../components/sections/fun/Fun";

const AfterHours = () => {
  return (
    <div>
      <Fun />
    </div>
  );
};

export default AfterHours;
